import { render } from "./index.vue?vue&type=template&id=cea0cfa4&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=cea0cfa4&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-cea0cfa4"

export default script